(function () {
  'use strict';

  function getDiscountPercent(container) {
    var percent = parseInt(container.getAttribute('data-sale-discount-percent'), 10);
    return isNaN(percent) ? 0 : percent;
  }

  function computeSalePrice(originalCents, percent) {
    return Math.round(originalCents * (100 - percent) / 100);
  }

  function refreshCurrencyDisplay() {
    if (window.jQuery) {
      window.jQuery(document).trigger('onCurrencyChange');
    }
  }

  function setCompareVisibility(pricingEl, moneyEl, showCompare) {
    if (!pricingEl) {
      return;
    }

    if (showCompare) {
      pricingEl.classList.add('has-compare');
      if (moneyEl) {
        moneyEl.classList.add('has-compare');
      }
      return;
    }

    pricingEl.classList.remove('has-compare');
    if (moneyEl) {
      moneyEl.classList.remove('has-compare');
    }
  }

  function applySalePricing(container, variant) {
    var percent = getDiscountPercent(container);
    if (!percent || !variant || !variant.price) {
      return;
    }

    var original = variant.price;
    var nativeCompare = variant.compare_at_price;
    var pricingEl = container.querySelector('[data-product-pricing]');
    var moneyEl = container.querySelector('[data-product-money]');
    var compareEl = container.querySelector('[data-product-compare-money]');

    if (!pricingEl || !moneyEl) {
      return;
    }

    if (nativeCompare && nativeCompare > original) {
      setCompareVisibility(pricingEl, moneyEl, true);
      refreshCurrencyDisplay();
      return;
    }

    var salePrice = computeSalePrice(original, percent);

    if (compareEl) {
      compareEl.setAttribute('data-money', String(original));
    }

    moneyEl.setAttribute('data-money', String(salePrice));
    setCompareVisibility(pricingEl, moneyEl, true);
    refreshCurrencyDisplay();
  }

  function getVariantFromSelector(container, selector) {
    var productJson = selector.getAttribute('data-product');

    if (!productJson) {
      return null;
    }

    try {
      var product = JSON.parse(productJson);
      var variantId = parseInt(selector.value, 10);
      return product.variants.find(function (variant) {
        return variant.id === variantId;
      }) || null;
    } catch (error) {
      return null;
    }
  }

  function initContainer(container) {
    if (container.getAttribute('data-sale-strikethrough-active') !== 'true') {
      return;
    }

    var selector = container.querySelector('[data-variant-selector]');

    if (!selector) {
      return;
    }

    selector.addEventListener('variant', function (event) {
      setTimeout(function () {
        var variant = event.detail && event.detail.variant;

        if (variant) {
          applySalePricing(container, variant);
        }
      }, 0);
    });

    var initialVariant = getVariantFromSelector(container, selector);

    if (initialVariant) {
      setTimeout(function () {
        applySalePricing(container, initialVariant);
      }, 0);
    }
  }

  function init() {
    document
      .querySelectorAll('[data-product-template][data-sale-strikethrough-active]')
      .forEach(initContainer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
